export default class Store {
  constructor() {
    this.headerType = null;
    this.footerType = null;
    this.isLoading = null;
    this.isLayoutSet = null;
    this.favicon = null;
    this.riaId = null;
    this.enterpriseId = null;
    this.redirectPath = null;
    this.notificationBellFlag = false;
  }
}
